export const FILTER_BASE = 'myads';
export const ALL = 'ALL';
export const DEFAULT_ARROW_SIZE = 24;
export const EXPECTED_ITEMS = 10;
export const EXPERIMENT_ID = {
    MY_ADS_CAR_INSURANCE: 'PAN-44625'
};
export const ADS_STATUES = {
    AD_STATUS: 'ad_status',
    AD_EXPIRED: 'ads_expired'
};

